import React from 'react';
import { Text } from '@skin-seoul/design-system';
import { TextHighlighter } from '@skin-seoul/utils';
export type HighlightedTextProps = {
  value: string;
  match: string;
};
export const HighlightedText = ({
  value,
  match
}: HighlightedTextProps) => <Text textStyle="paragraph.small" display="flex" flexDirection="row" whiteSpace="pre-wrap" data-sentry-element="Text" data-sentry-component="HighlightedText" data-sentry-source-file="HighlightedText.tsx">
    <TextHighlighter value={value} match={match.trim()} formatter={matched => <Text as="strong" textStyle="paragraph.small" fontWeight="bold">
          {matched}
        </Text>} data-sentry-element="TextHighlighter" data-sentry-source-file="HighlightedText.tsx" />
  </Text>;